module.exports = __webpack_public_path__ + "img/routerDefaultImg.1d85c2fc.png";